/**
  * vue-cal v3.11.0
  * (c) 2022 Antoni Andre <antoniandre.web@gmail.com>
  * @license MIT
  */
const a = ["Maandag", "Dinsdag", "Woensdag", "Donderdag", "Vrijdag", "Zaterdag", "Zondag"], e = ["Januari", "Februari", "Maart", "April", "Mei", "Juni", "Juli", "Augustus", "September", "Oktober", "November", "December"], n = "Jaren", d = "Jaar", r = "Maand", s = "Week", t = "Dag", o = "Vandaag", g = "Geen afspraken", k = "Hele dag", M = "Verwijderen", i = "Nieuwe afspraak aanmaken", y = "dddd D MMMM YYYY", D = { weekDays: a, months: e, years: "Jaren", year: "Jaar", month: "Maand", week: "Week", day: "Dag", today: "Vandaag", noEvent: "Geen afspraken", allDay: "Hele dag", deleteEvent: "Verwijderen", createEvent: "Nieuwe afspraak aanmaken", dateFormat: "dddd D MMMM YYYY" };
export {
  k as allDay,
  i as createEvent,
  y as dateFormat,
  t as day,
  D as default,
  M as deleteEvent,
  r as month,
  e as months,
  g as noEvent,
  o as today,
  s as week,
  a as weekDays,
  d as year,
  n as years
};
